import uuid from './uuid'
export default uuid() + new Date().getTime();
